module.exports = __webpack_public_path__ + "assets/img/weight_active.d707163c.png";